import React, {useEffect, useState} from "react";
import styled from "@emotion/styled";
import {eq, lte} from "lodash";
import {Nullable} from "modules/types";
const animDuration = 1;

const Wrapper = styled.div`
	.pulse-bubble {
		background: ${({theme}) => theme.guess.incorrectColor};
		padding: 2px;
	}
`;

const BubbleImg = styled.img`
	width: 20px;
	height: 20px;
	border-radius: 10px;

	transition: background ${String(animDuration)}s ease, padding ${String(animDuration)}s linear;
`;

interface IBubbleProps {
	src: string;
	strikes: Nullable<number> | undefined;
	index: number;
}

export const StrikeBubble: React.FC<IBubbleProps> = ({src, strikes, index}) => {
	const [curStrikes, setCurStrikes] = useState<Nullable<number> | undefined>(0);
	const [className, setClassName] = useState("");

	useEffect(() => {
		if (!eq(curStrikes, strikes) && lte(index, strikes)) {
			setCurStrikes(strikes);

			setClassName("pulse-bubble");

			setTimeout(() => {
				setClassName("");
			}, animDuration * 1000);
		}
	}, [curStrikes, strikes, index]);

	return (
		<Wrapper>
			<BubbleImg src={src} alt="non-started-timer" className={className} />
		</Wrapper>
	);
};
